import { dashboardsPath } from 'adapter/in/common/routes';

const buildBaseUrl = (protocol: string, domain: string, port: number, apiPrefix: string, pathUrl: string): string => {
    let url = `${protocol}//${domain}${port === 80 ? '' : `:${port}`}${apiPrefix}`;
    const dashboardLinkMatch = pathUrl.match(/(\/links\/[^/]*)(\/dashboards\/[^/]*)/);
    const reportLinkMatch = pathUrl.match(/\/reports\/links\/([^/]+)\/reports\/([^/]+)/);

    if (dashboardLinkMatch?.length === 3) {
        url = `${url}/${dashboardsPath}${dashboardLinkMatch[2]}${dashboardLinkMatch[1]}/proxy/api-v3`;
    }

    if (reportLinkMatch?.length === 3) {
        const [, linkId, reportId] = reportLinkMatch;
        url = `${url}/${dashboardsPath}/reports/${reportId}/links/${linkId}/proxy/api-v3`;
    }

    return url;
};

export default buildBaseUrl;
